var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size sm_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.$t("TITLE.MYKNOWLEDGE.BUG.REPORT")) +
                "\n                "
            )
          ]),
          _vm._v(" "),
          _c("dd", [
            _c(
              "div",
              { staticClass: "opinion_wrap" },
              [
                _c("p", { staticClass: "q_opinion" }, [
                  _vm._v(_vm._s(_vm.$t("MESSAGE.BUGREPORT.OPINION.QUESTION")))
                ]),
                _vm._v(" "),
                _vm.isScmsContents
                  ? [
                      _c("ul", { staticClass: "opinion_list" }, [
                        _c(
                          "li",
                          {
                            class:
                              _vm.selFlag && _vm.selVal === "D" ? "active" : "",
                            attrs: { "data-val": "D" },
                            on: {
                              click: function($event) {
                                return _vm.optSelect($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MESSAGE.BUGREPORT.OPINION.HAVE.QUESTION"
                                )
                              )
                            )
                          ]
                        )
                      ])
                    ]
                  : [
                      _c("ul", { staticClass: "opinion_list" }, [
                        _c(
                          "li",
                          {
                            class:
                              _vm.selFlag && _vm.selVal === "A" ? "active" : "",
                            attrs: { "data-val": "A" },
                            on: {
                              click: function($event) {
                                return _vm.optSelect($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MESSAGE.BUGREPORT.OPINION.MODEL.INACCURATE"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class:
                              _vm.selFlag && _vm.selVal === "B" ? "active" : "",
                            attrs: { "data-val": "B" },
                            on: {
                              click: function($event) {
                                return _vm.optSelect($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MESSAGE.BUGREPORT.OPINION.MORE.INFORMATION"
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            class:
                              _vm.selFlag && _vm.selVal === "C" ? "active" : "",
                            attrs: { "data-val": "C" },
                            on: {
                              click: function($event) {
                                return _vm.optSelect($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("MESSAGE.BUGREPORT.OPINION.MUST.FIXED")
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isMobile,
                                expression: "!isMobile"
                              }
                            ],
                            class:
                              _vm.selFlag && _vm.selVal === "D" ? "active" : "",
                            attrs: { "data-val": "D" },
                            on: {
                              click: function($event) {
                                return _vm.optSelect($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "MESSAGE.BUGREPORT.OPINION.HAVE.QUESTION"
                                )
                              )
                            )
                          ]
                        )
                      ])
                    ],
                _vm._v(" "),
                _c("div", { staticClass: "opinion_textarea align_right" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.detailComments,
                        expression: "detailComments"
                      }
                    ],
                    staticClass: "textarea_ty w100p",
                    staticStyle: { resize: "none" },
                    attrs: {
                      rows: "4",
                      maxlength: "200",
                      disabled: _vm.optTextFlag,
                      placeholder: _vm.$t(
                        "MESSAGE.BUGREPORT.OPINION.PLACEHOLDER"
                      )
                    },
                    domProps: { value: _vm.detailComments },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.detailComments = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "textarea_counter" }, [
                    _vm._v(_vm._s(_vm.detailComments.length) + " / 200")
                  ])
                ])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnSend }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SEND")))]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df59acfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df59acfe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/common/popup/BugReportPopup.vue
// module id = a9ub
// module chunks = 0